/**
 * Normalise une valeur pour recherche texte (gère number, null, etc.).
 */
export function searchNormalize(value) {
  if (value == null || value === '') return '';
  return String(value).toLowerCase();
}

/**
 * true si query vide, ou si au moins un champ contient la query (insensible à la casse).
 */
export function searchFieldsMatch(query, fields) {
  const q = searchNormalize(query);
  if (!q) return true;
  const list = Array.isArray(fields) ? fields : [fields];
  return list.some((f) => searchNormalize(f).includes(q));
}
